var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:[
    `alert--${_vm.type}`,
    { 'alert--critical' : _vm.critical }
  ]},[_c(_vm.icon,{tag:"component",staticClass:"alert__icon"}),_c('p',{staticClass:"alert__caption"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.caption)+" ")]})],2),(_vm.closeButton)?_c('x-icon',{staticClass:"alert__close",on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }